<template>
  <table-ag
    ref="agClimaDetallado"
    :row-data="datos"
    :columnDefs="columns"
    :menu-filter="{ group: 'group', active: true }"
    :actions="true"
    :components="components"
    :typeSelection="limitSelection > 1 ? 'multiple' : 'single'"
    :limitSelection="limitSelection"
    :onDeselectEmptyData="true"
    @selected="selected"
  ></table-ag>
</template>
<script>
import tableAg from "../dashboard/tableAg.vue";
import tooltipGraphBarHClima from "./components/tooltipGraphBarHClima.vue";
import cellComparison from "./components/cellComparison.vue";
import buttonsActionGroupClima from "./components/buttonsActionGroupClima.vue";
export default {
  data() {
    return {
      columns: [
        {
          field: "group",
          hide: true,
          editable: false,
          getQuickFilterText: (params) => {
            return `FILTER_${params.value.replace(" ", "")}_GRUPO`;
          },
        },
        {
          field: "name",
          headerName: "Subgrupo",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          tooltipValueGetter: (params) => {
            return params.value;
          },
        },
        {
          field: "CClimad",
          headerName: "N",
          valueGetter: (params) => {
            return params.data[params.colDef.field].n
              ? params.data[params.colDef.field].n
              : 0;
          },
          filter: "agTextColumnFilter",
          editable: false,
          width: 90,
        },
        {
          field: "apoyod",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Apoyo",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "apoyod",
          tooltipComponent: "TooltipGraphBarHClima",
        },
        {
          field: "calidadd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Calidad",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "calidadd",
          tooltipComponent: "TooltipGraphBarHClima",
        },
        {
          field: "innovaciond",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Innovación",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "innovaciond",
          tooltipComponent: "TooltipGraphBarHClima",
        },
        {
          field: "metasd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Meta",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "metasd",
          tooltipComponent: "TooltipGraphBarHClima",
        },
        {
          field: "CClimad",
          valueGetter: (params) => {
            return `${params.data[params.colDef.field].p.toFixed(2)}`;
          },
          headerName: "Total",
          filter: "agTextColumnFilter",
          cellClass: (params) => this.cellClassRules(params, true),
          cellRenderer: "CellComparison",
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          editable: false,
          resizable: true,
        },
        {
          field: "_id",
          headerName: "",
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionGroupClima",
          cellRendererParams: {
            copyLink: this.copyLink,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          sortable: false,
          width: 50,
        },
      ],
      components: {
        TooltipGraphBarHClima: () => {
          return {
            render: (h) =>
              h(tooltipGraphBarHClima, {
                props: {
                  nameQuadrants: this.nameQuadrants,
                  nameRanges: this.nameRanges,
                  getRange: this.getRange,
                },
                on: {},
              }),
          };
        },
        CellComparison: () => {
          return {
            render: (h) =>
              h(cellComparison, {
                props: {
                  nameRanges: this.nameRanges,
                  getRange: this.getRange,
                },
                on: {},
              }),
          };
        },
        ButtonsActionGroupClima: () => {
          return {
            render: (h) =>
              h(buttonsActionGroupClima, {
                props: {
                  copyLink: this.copyLink,
                },
                on: {},
              }),
          };
        },
      },
    };
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    limitSelection: Number,
    getRange: {
      type: Function,
      required: true,
    },
    nameQuadrants: {
      type: Object,
      required: true,
    },
    nameRanges: {
      type: Object,
      required: true,
    },
  },
  beforeMount() {
    // console.log(this.datos)
  },
  methods: {
    cellClassRules(p, text = false) {
      p = p.value;
      if (!text) {
        if (p) {
          return `rangoT${p}`;
        }
        return "rangoT0";
      }
      if (text) {
        if (p) {
          const r = this.getRange(p);
          return `textT${r}`;
        }
        return "textT0";
      }
    },
    selected(i) {
      if (!Array.isArray(i)) i = [i];
      this.$emit("setFilterTable", i);
    },
    deselect() {
      this.$refs.agClimaDetallado.deselectAll();
    },
    deselectOne(filter) {
      filter = filter.map((x) => {
        return { name: x.gr.split("AGR-")[1], subGrupo: x.subgr };
      });
      // Se debe organizar el metodo deselectOne, con el fin de que se pueda enviar los nombres de los atributos a comparar, min 2
      // this.$refs.agClimaDetallado.deselectOne(filter)
    },
    // Others
    copyLink(f) {
      this.$emit("copyLink", f);
    },
  },
  watch: {},
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}

/* Backgrounds */

.rangoT1 {
  background-color: #76be7c !important;
  border: solid 1px #62a468;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT2 {
  background-color: #d9ead3 !important;
  border: solid 1px #b6dca9;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT3 {
  background-color: #fde8af !important;
  border: solid 1px #f3d583;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT4 {
  background-color: #f5bc95 !important;
  border: solid 1px #f6b182;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT5 {
  background-color: #fda0a0 !important;
  border: solid 1px #f68585;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT0 {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
  color: rgba(65, 64, 64, 0.91);
}

/* Text Colors */

.textT1 {
  color: #54a459 !important;
}

.textT2 {
  color: #abe59d !important;
}

.textT3 {
  color: #ffe196 !important;
}

.textT4 {
  color: #f5bc95 !important;
}

.textT5 {
  color: #fda0a0 !important;
}

.textT0 {
  color: rgba(165, 165, 165, 0.94);
}
</style>



// WEBPACK FOOTER //
// src/components/climan/TableGroups.vue